import { render, staticRenderFns } from "./CrearAlertaModal.vue?vue&type=template&id=0c439293&"
import script from "./CrearAlertaModal.vue?vue&type=script&lang=ts&"
export * from "./CrearAlertaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports